import axios from 'axios'
import type {
  CreateDocumentRequest,
  CreateFolderRequest,
  DocumentDto,
  DocumentSummaryDto,
  FileMetadataDto,
  FolderDto,
  UpdateDocumentRequest,
  UpdateFolderRequest,
} from '../Models/Workspace'

const apimSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY

export const workspaceAxios = axios.create({
  baseURL: process.env.REACT_APP_WORKSPACE_API_BASE_URL ?? 'http://localhost:7074/api',
  headers: {
    'Content-Type': 'application/json',
    ...(apimSubscriptionKey
      ? { 'Ocp-Apim-Subscription-Key': apimSubscriptionKey }
      : {}),
  },
})

export const workspaceApi = {
  // Folders
  getFolders: () =>
    workspaceAxios.get<FolderDto[]>('/GetFolders').then((r) => r.data),
  createFolder: (body: CreateFolderRequest) =>
    workspaceAxios.post<FolderDto>('/CreateFolder', body).then((r) => r.data),
  updateFolder: (id: string, patch: UpdateFolderRequest) =>
    workspaceAxios.patch<FolderDto>(`/UpdateFolder/${id}`, patch).then((r) => r.data),
  deleteFolder: (id: string) =>
    workspaceAxios.delete(`/DeleteFolder/${id}`),

  // Documents
  getDocuments: (params?: { folderId?: string; taskId?: string }) =>
    workspaceAxios
      .get<DocumentSummaryDto[]>('/GetDocuments', { params })
      .then((r) => r.data),
  getDocument: (id: string) =>
    workspaceAxios.get<DocumentDto>(`/GetDocument/${id}`).then((r) => r.data),
  createDocument: (body: CreateDocumentRequest) =>
    workspaceAxios.post<DocumentDto>('/CreateDocument', body).then((r) => r.data),
  updateDocument: (id: string, patch: UpdateDocumentRequest) =>
    workspaceAxios
      .patch<DocumentDto>(`/UpdateDocument/${id}`, patch)
      .then((r) => r.data),
  deleteDocument: (id: string) =>
    workspaceAxios.delete(`/DeleteDocument/${id}`),

  // Files
  getFiles: (params?: { folderId?: string; documentId?: string; taskId?: string }) =>
    workspaceAxios
      .get<FileMetadataDto[]>('/GetFiles', { params })
      .then((r) => r.data),
  uploadFile: (formData: FormData) =>
    workspaceAxios
      .post<FileMetadataDto>('/UploadFile', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data),
  deleteFile: (id: string) =>
    workspaceAxios.delete(`/DeleteFile/${id}`),
}
